import Spaces from "../../sharedComponents/components/Spaces";
import React from "react";

export default function(props: any) {
  
  return(<section className={"text--center"}>
    <Spaces n={3}/>
    Aucun résultat à afficher
  </section>);
}